import React from 'react';
import styles from './StanBadge.module.css';
import { cn } from '@/lib';

export type BadgeVariant = 'primary' | 'success' | 'destructive' | 'muted' | 'default';
export type BadgeSize = 'sm' | 'md' | 'lg';

export interface StanBadgeProps {
    variant?: BadgeVariant;
    size?: BadgeSize;
    icon?: React.ReactNode;
    children: React.ReactNode;
    className?: string;
    onClick?: (e: React.MouseEvent<HTMLElement>) => void;
    ariaLabel?: string;
}

export const StanBadge = React.memo<StanBadgeProps>(
    ({ variant = 'default', size = 'md', icon, children, className, onClick, ariaLabel }) => {
        const isClickable = !!onClick;
        const Comp = isClickable ? 'button' : 'span';

        const badgeClasses = cn(
            styles['stan-badge'],
            styles[variant],
            styles[size],
            isClickable && styles.clickable,
            className
        );

        return (
            <Comp
                className={badgeClasses}
                onClick={onClick}
                aria-label={ariaLabel}
                type={isClickable ? 'button' : undefined}
            >
                {icon && (
                    <span className={styles.icon} aria-hidden='true'>
                        {icon}
                    </span>
                )}
                {children}
            </Comp>
        );
    }
);

StanBadge.displayName = 'StanBadge';
